global.ListingBlock = (function ($) {
    var $container = $('.listing-block');
	var $listingFilter = $('.js-listing-block-filter');
	var $lastFilterItem = $('.js-filter-item:last-child');
	var $firstFilterItem = $('.js-filter-item:first-child');
	var $arrowLeft = $('.listing-block__filter-arrow--left');
	var $arrowRight = $('.listing-block__filter-arrow--right');

    function init() {
		if ($listingFilter.length === 0) {
			return;
        }
        showActiveFilterItem();
		$(window).on('resize', toggleArrows);
		$arrowLeft.on('click', scrollLeft);
		$arrowRight.on('click', scrollRight);
		setTimeout(function () { toggleArrows(); }, 500);

		$('.js-filter-year-dropdown').on('change', function () {
			if ($(this).find('option:selected').hasClass('js-external-link')) {
				window.location = $(this).val();
				return;
			}
			$(this).parents('form').submit();
		});
    }

	function scrollRight() {
        if (!isLastItemVisible()) {
            var currentMargin = parseFloat($listingFilter.css('margin-left'));
            var newMargin = Math.ceil((currentMargin - 200) / 200) * 200;
			$listingFilter.css('margin-left', newMargin + 'px');
			setTimeout(function() { toggleArrows(); }, 500);
        }
    }

    function scrollLeft() {
        var currentMargin = parseFloat($listingFilter.css('margin-left'));
        var newMargin = Math.ceil((currentMargin + 200) / 200) * 200;
        if (newMargin <= 0) {
            $listingFilter.css('margin-left', newMargin + 'px');
		}
        setTimeout(function () { toggleArrows(); }, 500);
    }

    function toggleArrows() {
		if (isFirstItemVisible()) {
			$arrowLeft.hide();
		} else {
			$arrowLeft.show();
		}

		if (isLastItemVisible()) {
			$arrowRight.hide();
		} else {
			$arrowRight.show();
		}
    }

    function showActiveFilterItem() {
        var $item = $('.listing-block__filter-item.active');

		if ($item.length === 0) {
			return;
		}

        if (($item.position().left + 100) > $container.width()) {
            var newMargin = Math.ceil((($item.position().left + 100) - $container.width()) / 200) * -200;
            $listingFilter.css('margin-left', newMargin + 'px');
        }
    }

	function isFirstItemVisible() {
		if ($firstFilterItem === undefined || $firstFilterItem.position() === undefined) {
			return false;
		}
		return $firstFilterItem.position().left >= 0;
	}

	function isLastItemVisible() {
		if ($lastFilterItem === undefined || $lastFilterItem.position() === undefined) {
			return false;
		}
		return $lastFilterItem.position().left < $container.width() - 100;
    }

    return {
        init: init
    };
})(jQuery);
